<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="props.classes">
        <span class="md:flex w-full hidden items-center">
            <span>by INE with</span>
            <feather-icon icon="CodeIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
            <div class="app-version ml-auto color-current text-grey">v{{ props.version }}</div>
        </span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
        version: {
            type: String
        }
    }
}
</script>
